import { Contest } from "interfaces/leaderboard/contest.ts";
import { ContestItemHome } from "components/contests/contest-display-items";
import { useAppSelector } from "state/hooks.ts";
import { getNonDeletedContests } from "state/slices/contests-slice.ts";
import styles from "components/my-bets/styles.module.css";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text.tsx";
import { CONTEST_STATE } from "utils/constants.ts";
import { ContestWeight } from "interfaces/contest";

interface OpenContestsProps {
  contestWeights: ContestWeight[];
}

// Add weight to Contest type for our sorted contests
interface ContestWithWeight extends Contest {
  weight?: number;
}

const OpenContests = ({ contestWeights }: OpenContestsProps) => {
  const activeContests = useAppSelector(getNonDeletedContests);

  const openContests = activeContests.filter(c => c.state === CONTEST_STATE.OPEN);

  const contestsWithWeights = openContests.map((contest) => {
    const weight = contestWeights.find((cw) => cw.contest_id === contest.id)?.weight;
    return { ...contest, weight };
  });

  const contestsSortedByWeight = contestsWithWeights.sort((a, b) => {
    const weightA = a.weight || 0;
    const weightB = b.weight || 0;
    return weightB - weightA;
  });

  if (contestsSortedByWeight.length === 0) {
    return (
      <div className={styles.noBetsTextContainer}>
        <BlockyHeavyText>No open contests</BlockyHeavyText>
      </div>
    );
  }

  return (
    <>
      {contestsSortedByWeight.map((contest: ContestWithWeight) => (
        <ContestItemHome
          key={contest.id}
          contest={contest}
        />
      ))}
    </>
  );
};

export default OpenContests;